export const convertDateFormat = (dateStr: string) =>
  dateStr.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3");
